import React from "react";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { Form } from "antd";
import { INPUT_TYPES } from "constants/input-types";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import cx from "classnames";
import { Button } from "antd";
import { COMPANY_TYPES } from "constants/index";
import "styles/form.css";
import CompanyService from "services/company-service";
const FormItem = Form.Item;
const BULK_UPLOAD_FIELDS = new OrderedMap({
    anchor: {
        className: "form-field fb-20",
        label: "Anchor",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name",
        onSearch: () => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Anchor"))
    },

    seller: {
        label: "Distributor",
        className: "form-field fb-20",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name",
        onSearch: () => CompanyService.getCompanyProfiles(COMPANY_TYPES.get("Distributor"))
    },
    file: {
        type: INPUT_TYPES.FILE,
        btnLabel: "Upload File",
        showUploadList: false
    }
});

class BulkCaseCreate extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    submitForm = () => {
        this.props.form.validateFields((err, values) => {
            this.props.uploadBulk(values);
        }); 
    }
    render() {
        return (
            <Form
                layout={"vertical"}
                className={cx("form", "br-3")}
            >
                <div className={"form-row"}>
                    {BULK_UPLOAD_FIELDS
                        .map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        )
                        .toList()
                        .toJS()}
                </div>
                <div className="d-flex justify-content-flex-end">
                    <FormItem className={cx("m-0")}>
                        <Button
                            onClick={this.submitForm}
                            type="primary"
                            icon={"plus"}>
                            {"Add"}
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

BulkCaseCreate.propTypes = {
    form: PropTypes.object,
    uploadBulk: PropTypes.func
};

export default Form.create({})(BulkCaseCreate);
